"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var is_1 = require("./_helpers/is");
/**
 * 判断某个对象是否是数组类型
 * @param  {any}  obj 需要判断的Object
 * @return {boolean}      对象是否是数组类型
 */
function isArray(obj) {
    return is_1.default('Array', obj);
}
exports.default = isArray;
//# sourceMappingURL=is-array.js.map